<div class="modal-header" ngxModalDraggable>
  <h3 class="modal-title pull-left">
    <svg viewBox="0 0 8 8" class="icon text-warning" inlineSVG="#exclamation-triangle" *ngIf="options?.hasSafetyCheck">
    </svg>
    {{question}}
  </h3>
  <button type="button" class="btn-close pull-right" (click)="hideConfirmationModal()" aria-label="Close">

  </button>
</div>
<div class="modal-body" *ngIf="description">
  <div class="custom-control custom-checkbox d-flex" *ngIf="options?.hasSafetyCheck">
    <input type="checkbox" class="custom-control-input" id="confirmCheckBox" (change)="isYesDisabled = !isYesDisabled">
    <label class="custom-control-label ms-1" for="confirmCheckBox">{{description}}</label>
  </div>
  <p class="text-pre" *ngIf="!options?.hasSafetyCheck">{{description}}</p>
</div>
<div class="modal-footer">
  <div class="text-end">
    <button type="button" class="btn btn-success btn-lg px-5 {{options.yesClass}}" *ngIf="options.showYes"
            (click)="onConfirm()"
            [ngClass]="options.yesClass == null ? {'btn-success': !options?.hasSafetyCheck, 'btn-danger': options?.hasSafetyCheck} : {}"
            [disabled]="options?.hasSafetyCheck && isYesDisabled">
      {{options.yesLabel}}
    </button>
    <button type="button" class="btn btn-default btn-lg ms-4 px-8 {{options.noClass}}" (click)="onCancel()" *ngIf="options.showNo">
      {{options.noLabel}}
    </button>
  </div>
</div>
